module.exports = __webpack_public_path__ + "img/red-get-fail.0205686d.png";